function deepEqual(obj1: any, obj2: any): boolean {
  if (obj1 === obj2) { return true } // Примитивы и ссылки на один объект

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false // Если один из них не объект или null
  }

  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) { return false } // Разное количество ключей

  return keys1.every(key => deepEqual(obj1[key], obj2[key])) // Рекурсивно сравниваем значения)
}

export default deepEqual
